/* eslint-disable sort-keys */
import { NodeSchemaProperties, NodeUiSchemaProperties } from '../../../@types/NodeSchemaProperties';

export const mobileV3LocalizationPaymentCaptureSchema: NodeSchemaProperties = {
  paymentCaptureScreen: {
    title: '#23 Payment Capture Screen',
    type: 'object',
    properties: {
      'header:enable': {
        description: '[paymentCaptureScreen.header]',
        title: '#1 Header',
        type: 'boolean',
      },
      header: {
        type: 'string',
      },
      'paymentProviderNotSupportMessage:enable': {
        description: '[paymentCaptureScreen.paymentProviderNotSupportMessage]',
        title: '#2 Payment Provider Not Support Message',
        type: 'boolean',
      },
      paymentProviderNotSupportMessage: {
        type: 'string',
      },
      'currency:enable': {
        description: '[paymentCaptureScreen.currency]',
        title: '#3 Currency',
        type: 'boolean',
      },
      currency: {
        type: 'string',
      },
      'pleaseProvideCreditCardMessage1:enable': {
        description: '[paymentCaptureScreen.pleaseProvideCreditCardMessage1]',
        title: '#4 Please Provide Credit Card Message 1',
        type: 'boolean',
      },
      pleaseProvideCreditCardMessage1: {
        type: 'string',
      },
      'pleaseProvideCreditCardMessage2:enable': {
        description: '[paymentCaptureScreen.pleaseProvideCreditCardMessage2]',
        title: '#5 Please Provide Credit Card Message 2',
        type: 'boolean',
      },
      pleaseProvideCreditCardMessage2: {
        type: 'string',
      },
      'cardWillNotBeChargedMessage:enable': {
        description: '[paymentCaptureScreen.cardWillNotBeChargedMessage]',
        title: '#6 Card Will Not Be Charged Message',
        type: 'boolean',
      },
      cardWillNotBeChargedMessage: {
        type: 'string',
      },
      'captureDisabled:enable': {
        description: '[paymentCaptureScreen.captureDisabled]',
        title: '#7 Capture Disabled',
        type: 'boolean',
      },
      captureDisabled: {
        type: 'string',
      },
      disabledPaymentRequirementTextHtml: {
        title: '#8 Disabled Payment Requirement Text Html',
        type: 'object',
        properties: {
          'text:enable': {
            description: '[paymentCaptureScreen.disabledPaymentRequirementTextHtml.text]',
            title: '#8.1 Text',
            type: 'boolean',
          },
          text: {
            type: 'string',
          },
          'type:enable': {
            description: '[paymentCaptureScreen.disabledPaymentRequirementTextHtml.type]',
            title: '#8.2 Type',
            type: 'boolean',
          },
          type: {
            enum: ['PLAIN_TEXT', 'HTML'],
            type: 'string',
          },
          'useDefaultStyles:enable': {
            description:
              '[paymentCaptureScreen.disabledPaymentRequirementTextHtml.useDefaultStyles]',
            title: '#8.3 Use Default Styles',
            type: 'boolean',
          },
          useDefaultStyles: {
            type: undefined,
            enum: [true, false],
          },
        },
      },
      error: {
        title: '#9 Error',
        type: 'object',
        properties: {
          'title:enable': {
            description: '[paymentCaptureScreen.error.title]',
            title: '#9.1 Title',
            type: 'boolean',
          },
          title: {
            type: 'string',
          },
          'description:enable': {
            description: '[paymentCaptureScreen.error.description]',
            title: '#9.2 Description',
            type: 'boolean',
          },
          description: {
            type: 'string',
          },
        },
      },
      'paymentProviderNotSet:enable': {
        description: '[paymentCaptureScreen.paymentProviderNotSet]',
        title: '#10 Payment Provider Not Set',
        type: 'boolean',
      },
      paymentProviderNotSet: {
        type: 'string',
      },
      errorModal: {
        title: '#11 Error Modal',
        type: 'object',
        properties: {
          'buttonTitle:enable': {
            description: '[paymentCaptureScreen.errorModal.buttonTitle]',
            title: '#11.1 Button Title',
            type: 'boolean',
          },
          buttonTitle: {
            type: 'string',
          },
          'title:enable': {
            description: '[paymentCaptureScreen.errorModal.title]',
            title: '#11.2 Title',
            type: 'boolean',
          },
          title: {
            type: 'string',
          },
        },
      },
      successModal: {
        title: '#12 Success Modal',
        type: 'object',
        properties: {
          'buttonTitle:enable': {
            description: '[paymentCaptureScreen.successModal.buttonTitle]',
            title: '#12.1 Button Title',
            type: 'boolean',
          },
          buttonTitle: {
            type: 'string',
          },
          'title:enable': {
            description: '[paymentCaptureScreen.successModal.title]',
            title: '#12.2 Title',
            type: 'boolean',
          },
          title: {
            type: 'string',
          },
          'description:enable': {
            description: '[paymentCaptureScreen.successModal.description]',
            title: '#12.3 Description',
            type: 'boolean',
          },
          description: {
            type: 'string',
          },
        },
      },
    },
  },
};

export const mobileV3LocalizationPaymentCaptureUiSchema: NodeUiSchemaProperties = {
  paymentCaptureScreen: {
    header: {
      'ui:label': false,
      'ui:readonly': true,
    },
    paymentProviderNotSupportMessage: {
      'ui:label': false,
      'ui:readonly': true,
    },
    currency: {
      'ui:label': false,
      'ui:readonly': true,
    },
    pleaseProvideCreditCardMessage1: {
      'ui:label': false,
      'ui:readonly': true,
    },
    pleaseProvideCreditCardMessage2: {
      'ui:label': false,
      'ui:readonly': true,
    },
    cardWillNotBeChargedMessage: {
      'ui:label': false,
      'ui:readonly': true,
    },
    captureDisabled: {
      'ui:label': false,
      'ui:readonly': true,
    },
    disabledPaymentRequirementTextHtml: {
      text: {
        'ui:label': false,
        'ui:readonly': true,
      },
      type: {
        'ui:label': false,
        'ui:readonly': true,
      },
      useDefaultStyles: {
        'ui:label': false,
        'ui:readonly': true,
        'ui:widget': 'select',
      },
    },
    error: {
      title: {
        'ui:label': false,
        'ui:readonly': true,
      },
      description: {
        'ui:label': false,
        'ui:readonly': true,
      },
    },
    paymentProviderNotSet: {
      'ui:label': false,
      'ui:readonly': true,
    },
    errorModal: {
      buttonTitle: {
        'ui:label': false,
        'ui:readonly': true,
      },
      title: {
        'ui:label': false,
        'ui:readonly': true,
      },
    },
    successModal: {
      buttonTitle: {
        'ui:label': false,
        'ui:readonly': true,
      },
      title: {
        'ui:label': false,
        'ui:readonly': true,
      },
      description: {
        'ui:label': false,
        'ui:readonly': true,
      },
    },
  },
};
